export const voting = function () {
    const votongButton = document.querySelectorAll('.header__additional_popieram');
    votongButton.forEach((item) => {
        function showVoted() {            
            let votedTxt = 'Liczba osób popierających zmianę <br>rowerowej edukacji dzieci';
            item.classList.add('__jsVoted');
            let copy = item.querySelector('strong');
            if (copy) copy.innerHTML = votedTxt;
        }
        if (document.querySelector('.intro')) {
            console.log('jest intro')
            window.addEventListener("scroll", function() {
                if (window.scrollY >= document.querySelector('.intro').offsetHeight + 20 && item.classList.contains('__sg')) {
                    console.log('za intro i ma klase sg')
                    document.querySelector('.__sg').style.opacity = 1;
                    document.querySelector('.__sg').style.zIndex = 4;
                }
                else if (window.scrollY < document.querySelector('.intro').offsetHeight + 20 && item.classList.contains('__sg')) {
                    console.log('przed intro i ma klase sg')
                    document.querySelector('.__sg').style.opacity = 0;
                    document.querySelector('.__sg').style.zIndex = -1;
                }
            });
        }
        var lc = localStorage.getItem("rowerowazmiana");        
        if (lc) {          
            showVoted();
        } else item.addEventListener('click', async (e) => {

            const endpoint = item.dataset.url? item.dataset.url:item.dataset.src;
            
            if (lc || !endpoint) return;
            try {
                item.classList.add('__jsPending');
                const response = await fetch(endpoint, {method: 'POST'});
                if (!response.ok) {
                  throw new Error(`Server responded with status: ${response.status}`);
                }
                const data = await response.json();
                if (data.ok) {
                    item.classList.remove('__jsPending')
                    item.classList.add('__jsActive');

                    setTimeout(()=>{ item.classList.remove('__jsActive') }, 4500);
                    

                    showVoted();

                    document.querySelectorAll('.header__additional_count').forEach(c => {
                        c.innerHTML = data.counter;
                    });
                    const counter = document.querySelectorAll('.header__additional_count');
                    localStorage.setItem("rowerowazmiana", 1);
                    lc = counter;
                }
            } catch (error) {


            }
                        
        })
    })
}